import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { formatMoney, makeProductLink } from '../ShoppingCartUtils/Helpers';

const ShoppingCartItem = (props) => {
    return (
        <div className="cart-item">
            <div className="cart-item__img__container" aria-hidden="true">
                <div className="cart-item__img__mask" aria-hidden="true"></div>
            </div>
            <div className="cart-item__text__content"> 
                <a href={makeProductLink(props.course_id,props.title)} className="cart-item__listing__title" aria-label={"Cart item number " + props.cart_number + ", " + ReactHtmlParser(props.title)}>{ReactHtmlParser(props.title)}</a>
                <button 
                    className="cart-item__remove__button" 
                    onClick={props.remove_handler}
                    data-course-id={props.course_id}>
                    <i className="fa fa-trash" aria-hidden="true"></i> Remove
                </button>
            </div>
            <div className="cart-item__cta__area">
                <div className="cart-item__prices">
                    <span className="cart-item__listing__price" tabIndex="0" aria-label={"The item quantity is " +  props.quantity + " at " + "$" + props.unit_cost + " equaling " + `$${formatMoney(props.unit_total, 2, '.', ',')}`}><span className="cart-item__price__part" aria-hidden="true">({props.quantity}&nbsp;@&nbsp;{props.unit_cost})</span><span className="cart-item__price__part" aria-hidden="true">{`$${formatMoney(props.unit_total, 2, '.', ',')}`}</span></span>
                </div>
                <div className="cart-item__add__cart__grp dropdown">
                    <button type="button" id={"dropdownMenuButton"+props.course_id} className="cart-item__add__cart add-cart btn btn-mid-green btn-mid-green--cr451 dropdown-toggle btn-raised"  data-toggle="dropdown"  aria-label={'Add ' + props.title + ' course to cart'} aria-expanded="false" aria-haspopup="true">Modify</button>
                    <div className="cart-item__dropdown__menu dropdown-menu" aria-labelledby={"dropdownMenuButton"+props.course_id}>
                        <form className="cart-quantity-update-form" onSubmit={props.update_quantity}>
                        <div>
                            <div className="cart-item__seats__msg">
                                Modify number of learners below.
                            </div>
                            <input type="hidden" value={props.course_id} className="course_id"/>
                            <input type="number" tabIndex="0" aria-label="Update course quantity field" className="cart_qty_field cart-item__modify__field" min="1" max="1000" defaultValue={props.quantity} required={true}/>
                        </div>
                        <button tabIndex="0" className="cart-item__add__cart btn btn-mid-green btn-mid-green--cr451 ttrans-n bradius-0 text-bold add-cart cart-quantity-update-button" aria-label={'Update the quantity of ' + props.title + ' course'}>Update</button>
                        </form>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        </div>
    );
};

export default ShoppingCartItem;